import ActionTypes from '../constants/ActionTypes';

export const socketConnected = socket => ({
  type: ActionTypes.SOCKET_CONNECTED,
  socket,
});

export const socketFetchSettings = ({ assessmentType, assessmentId }) => ({
  type: ActionTypes.SOCKET_FETCH_SETTINGS,
  assessmentType,
  assessmentId,
});

export const socketDisconnected = () => ({
  type: ActionTypes.SOCKET_DISCONNECTED,
});

export const initiateWebsocketConnection = () => ({
  type: ActionTypes.INITIATE_WEBSOCKET_CONNECTION,
});

export const initializeSocket = (connid, wid, sockid) => ({
  type: ActionTypes.INITIALIZING_SOCKET,
  connid,
  wid,
  sockid,
});

export const showMultiSessionPrompt = () => ({
  type: ActionTypes.SHOW_MULTI_SESSION_PROMPT,
});

export const startMonitorSession = data => ({
  type: ActionTypes.MONITOR_SESSION,
  data,
});

export const emitFailedEventsToSocket = () => ({
  type: ActionTypes.EMIT_FAILED_EVENTS_TO_SOCKET,
});

export const setFailedSocketEventsStatus = payload => ({
  type: ActionTypes.FAILED_SOCKET_EVENTS_STATUS,
  payload,
});

export const getActiveSession = payload => ({
  type: ActionTypes.GET_ACTIVE_SESSION,
  ...payload,
});

export const createdActiveSession = data => ({
  type: `${ActionTypes.CREATE_ACTIVE_SESSION}_SUCCESS`,
  value: data.isCreated,
});

export const setAlreadyActiveSession = data => ({
  type: `${ActionTypes.SET_ACTIVE_SESSION}_SUCCESS`,
  value: data.socketId,
});

export const emitWebsocketEvent = payload => ({
  type: ActionTypes.EMIT_WEBSOCKET_EVENT,
  payload,
});
